import { render } from "./CampaignsManagementDetailsPeriod.vue?vue&type=template&id=9358f9a6&scoped=true&ts=true"
import script from "./CampaignsManagementDetailsPeriod.vue?vue&type=script&lang=ts"
export * from "./CampaignsManagementDetailsPeriod.vue?vue&type=script&lang=ts"

import "./CampaignsManagementDetailsPeriod.vue?vue&type=style&index=0&id=9358f9a6&lang=scss"
import "./CampaignsManagementDetailsPeriod.vue?vue&type=style&index=1&id=9358f9a6&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9358f9a6"]])

export default __exports__